<template>
    <div>
        <auth-container :page="page">
            <h2 class="mb-4">Proposal Activitiess</h2>

            <div class="mx-auto">
                <b-row class="mb-3" align-v="end">
                    <b-col lg="6">
                        <b-form inline>
                            <b-input-group>
                                <b-form-input v-model="table.filter" placeholder="Search..." @input="filterChg"></b-form-input>

                                <b-input-group-append class="pointer mr-2">
                                    <b-input-group-text @click="clearFilter">
                                        <font-awesome-icon :icon="['fas', 'times']" />
                                    </b-input-group-text>
                                </b-input-group-append>
                            </b-input-group>

                            <b-input-group prepend="Fiscal Year">
                                <b-form-select v-model.number="advancedFilter.fiscalYear" :options="fiscalYear.options" @change="get(false)" class="mr-2">
                                    <template #first>
                                        <b-form-select-option :value="null">-- All --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-input-group>

                            <b-button variant="primary" type="button" @click="table.showAdvancedFilter = !table.showAdvancedFilter">Advanced Filter</b-button>
                        </b-form>
                    </b-col>
                    <b-col lg="6" class="text-right">
                        <div class="ml-auto">
                            Showing {{showingFirst}} - {{showingLast}}
                            of {{table.total}}
                        </div>
                    </b-col>
                </b-row>

                <b-collapse v-model="table.showAdvancedFilter" class="my-3">
                    <b-card bg-variant="light">
                        <b-row>
                            <b-col lg="4">
                                <div class="form-group row">
                                    <label for="advancedFilter.dam" class="col-lg-5 col-form-label">Dam NID_ID</label>
                                    <div class="col-lg-7">
                                        <b-typeahead id="advancedFilter.dam"
                                                     v-model="advancedFilter.dam"
                                                     :data="advancedFilter.options.dam"
                                                     :max-matches="100" :minMatchingChars="1">
                                        </b-typeahead>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="advancedFilter.sponsor" class="col-lg-5 col-form-label">Sponsor #</label>
                                    <div class="col-lg-7">
                                        <b-typeahead id="advancedFilter.sponsor"
                                                     v-model="advancedFilter.sponsor"
                                                     :data="advancedFilter.options.sponsor"
                                                     :max-matches="100" :minMatchingChars="1">
                                        </b-typeahead>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="advancedFilter.isActive" class="col-lg-5 col-form-label">Active?</label>
                                    <div class="col-lg-7">
                                        <b-form-select v-model="advancedFilter.isActive" id="advancedFilter.isActive">
                                            <b-form-select-option :value="null">-</b-form-select-option>
                                            <b-form-select-option value="y">Active</b-form-select-option>
                                            <b-form-select-option value="n">Inactive</b-form-select-option>
                                        </b-form-select>
                                    </div>
                                </div>
                            </b-col>
                            <b-col lg>
                                <div class="form-group row">
                                    <label for="advancedFilter.intendedStartDate.start" class="col-lg-3 col-form-label">Intended Start Date Range</label>
                                    <div class="col-lg-9">
                                        <div class="d-flex align-items-center justify-content-start">
                                            <div class="mr-2">
                                                <b-input-group>
                                                    <b-form-datepicker id="advancedFilter.intendedStartDate.start" v-model="advancedFilter.intendedStartDate.start"
                                                                       label-no-date-selected="Start Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

                                                    <b-input-group-append class="pointer">
                                                        <b-input-group-text @click="advancedFilter.intendedStartDate.start = null">
                                                            <font-awesome-icon :icon="['fas', 'times']" />
                                                        </b-input-group-text>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </div>
                                            <div>
                                                <b-input-group>
                                                    <b-form-datepicker id="advancedFilter.intendedStartDate.end" v-model="advancedFilter.intendedStartDate.end"
                                                                       label-no-date-selected="End Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

                                                    <b-input-group-append class="pointer">
                                                        <b-input-group-text @click="advancedFilter.intendedStartDate.end = null">
                                                            <font-awesome-icon :icon="['fas', 'times']" />
                                                        </b-input-group-text>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="advancedFilter.intendedEndDate.start" class="col-lg-3 col-form-label">Intended End Date Range</label>
                                    <div class="col-lg-9">
                                        <div class="d-flex align-items-center justify-content-start">
                                            <div class="mr-2">
                                                <b-input-group>
                                                    <b-form-datepicker id="advancedFilter.intendedEndDate.start" v-model="advancedFilter.intendedEndDate.start"
                                                                       label-no-date-selected="Start Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

                                                    <b-input-group-append class="pointer">
                                                        <b-input-group-text @click="advancedFilter.intendedEndDate.start = null">
                                                            <font-awesome-icon :icon="['fas', 'times']" />
                                                        </b-input-group-text>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </div>
                                            <div>
                                                <b-input-group>
                                                    <b-form-datepicker id="advancedFilter.intendedEndDate.end" v-model="advancedFilter.intendedEndDate.end"
                                                                       label-no-date-selected="End Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

                                                    <b-input-group-append class="pointer">
                                                        <b-input-group-text @click="advancedFilter.intendedEndDate.end = null">
                                                            <font-awesome-icon :icon="['fas', 'times']" />
                                                        </b-input-group-text>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <hr class="my-3" />
                        <div>
                            <b-button variant="primary" type="button" @click="get(false)" class="mr-2">Apply</b-button>
                            <b-button variant="secondary" type="button" @click="clearAdvancedFilter" class="mr-2">Clear</b-button>
                            <b-button variant="secondary" type="button" @click="table.showAdvancedFilter = false">Close</b-button>
                        </div>
                    </b-card>
                </b-collapse>

                <b-table striped responsive table-class="table-fixed-height border-bottom table-grid" sticky-header="60vh"
                         small show-empty
                         :items="items" :busy="table.loading"
                         :fields="table.fields"
                         :no-local-sorting="true"
                         :sort-by.sync="table.sort"
                         :sort-desc.sync="table.reverse"
                         @sort-changed="sortChg">
                    <template #table-busy>
                        <div class="text-center my-4">
                            <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
                        </div>
                    </template>
                    <template #cell(edit)="data">
                        <router-link :to="`/om/proposals/${data.item.id}`"><font-awesome-icon :icon="['fas', 'edit']" class="pointer text-primary" /></router-link>
                    </template>
                    <template #cell(dam)="data">
                        <router-link :to="`/dams/${data.value.id}`">{{data.value.name}}</router-link>
                    </template>
                    <template #cell(practice)="data">
                        <router-link :to="`/om/activities/${data.value.id}`">{{data.value.name}}</router-link>
                    </template>
                    <template #empty>
                        <h4>No records found.</h4>
                    </template>
                    <template #emptyfiltered>
                        <h4>No records found matching "{{table.filter}}".</h4>
                    </template>
                </b-table>
            </div>

            <fixed-action-bar>
               <b-pagination class="ml-auto mb-0" v-if="table.total > table.itemsPerPage" size="md" :total-rows="table.total" v-model="table.currentPage" :per-page="table.itemsPerPage" @change="pageChg" />
            </fixed-action-bar>
        </auth-container>
    </div>
</template>

<script>
	import _ from 'underscore';

	export default {
		name: 'ProposalList',
		data() {
			return {
                apiUrl: 'omproposals/all-activities',
				page: {
					errors: [],
					loading: true,
					showLogin: false,
					saveErrors: [],
					showModal: false
				},
				table: {
					fields: [
						{ key: 'edit', label: '' },
						{ key: 'fiscalYear', label: 'FY', sortable: true },
                        { key: 'proposalNumber', label: 'Proposal', sortable: true },
                        { key: 'isActive', label: 'Active', sortable: true, class: 'text-center', formatter: (value) => { return value ? '✔' : '-'; } },
                        { key: 'dam', label: 'Dam', sortable: true },
                        { key: 'practice', label: 'Practice', sortable: true },
                        { key: 'estimatedUnits', label: 'Est. Units', sortable: true, class: 'text-right', formatter: (value) => { return this.numberFormat(value, 2); } },
                        { key: 'estimatedCost', label: 'Est. Cost', sortable: true, class: 'text-right', formatter: (value) => { return this.money(value); } },
                        { key: 'approvedAmount', label: 'Approved O&M', sortable: true, class: 'text-right', formatter: (value) => { return this.money(value); } },
                        { key: 'approvedAdminAmount', label: 'Approved Admin', sortable: true, class: 'text-right', formatter: (value) => { return this.money(value); } },
                        { key: 'intendedStartDate', label: 'Intended Start', sortable: true, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') } },
                        { key: 'intendedEndDate', label: 'Intended End', sortable: true, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') } },
                        { key: 'ninetyDayDeadlineDate', label: '90-Day Deadline', sortable: true, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') } },
					],
                    sort: 'ninetyDayDeadlineDate_desc',
					reverse: false,
					itemsPerPage: 100,
					filter: null,
					currentPage: 1,
					total: 0,
					loading: false,
					showAdvancedFilter: false
				},
				items: [],
				advancedFilter: {
					dam: null,
					fiscalYear: null,
					sponsor: null,
                    intendedStartDate: {
						start: null,
						end: null
					},
                    intendedEndDate: {
						start: null,
						end: null
					},
					isActive: null,
					options: {
						fiscalYear: [],
						sponsor: [],
						dam: []
					}
				},
				fiscalYear: {
					options: []
				}
			}
		},
		computed: {
			showingFirst() {
				return (this.table.currentPage - 1) * this.table.itemsPerPage + 1
			},
			showingLast() {
				var max = (this.table.currentPage - 1) * this.table.itemsPerPage + this.table.itemsPerPage
				return max > this.table.total ? this.table.total : max;
			},
			advancedFilterFiscalYear() {
				return this.advancedFilter.fiscalYear;
			},
			advancedFilterSponsor() {
				return this.advancedFilter.sponsor;
			},
			advancedFilterDam() {
				return this.advancedFilter.dam;
			}
		},
		async created() {
			await this.get(true);
		},
		watch: {
			'$route': 'get',
			advancedFilterFiscalYear: _.debounce(function (query) { this.find('fiscalYear', query) }, 500),
			advancedFilterSponsor: _.debounce(function (query) { this.find('sponsor', query) }, 500),
			advancedFilterDam: _.debounce(function (query) { this.findDams('nid_id', query) }, 500)
		},
		methods: {
			getDb() {
				let sort = this.table.reverse ? this.table.sort + '_desc' : this.table.sort;
				let filter = this.table.filter !== null ? `&filter=${encodeURIComponent(this.table.filter)}` : '';

				let filterComplex = '';
				let filterValues = [];
				if (!this.isNullOrEmpty(this.advancedFilter.dam)) {
					filterValues.push(`dam:${this.advancedFilter.dam}`);
				}
				if (!this.isNullOrEmpty(this.advancedFilter.fiscalYear)) {
					filterValues.push(`fiscalYear:${this.advancedFilter.fiscalYear}`);
				}
				if (!this.isNullOrEmpty(this.advancedFilter.sponsor)) {
					filterValues.push(`sponsor:${this.advancedFilter.sponsor}`);
				}
				if (!this.isNullOrEmpty(this.advancedFilter.isActive)) {
					filterValues.push(`isActive:${this.advancedFilter.isActive}`);
				}
                if (!this.isNullOrEmpty(this.advancedFilter.intendedStartDate.start) || !this.isNullOrEmpty(this.advancedFilter.intendedStartDate.end)) {
                    let s = this.advancedFilter.intendedStartDate.start;
                    let e = this.advancedFilter.intendedStartDate.end;
					s = s === null ? 'any' : s;
					e = e === null ? 'any' : e;
                    filterValues.push(`intendedStartDate:${s},${e}`);
				}
                if (!this.isNullOrEmpty(this.advancedFilter.intendedEndDate.start) || !this.isNullOrEmpty(this.advancedFilter.intendedEndDate.end)) {
                    let s = this.advancedFilter.intendedEndDate.start;
                    let e = this.advancedFilter.intendedEndDate.end;
					s = s === null ? 'any' : s;
					e = e === null ? 'any' : e;
                    filterValues.push(`intendedEndDate:${s},${e}`);
				}

				if (filterValues.length > 0) filterComplex = '&filterComplex=' + filterValues.join('|');

				return this.$http.get(`${this.apiUrl}?sort=${sort}&page=${this.table.currentPage}&perPage=${this.table.itemsPerPage}${filter}${filterComplex}`, this.getTokenHeader());
			},
			async filterChg() {
				this.table.currentPage = 1;
				_.debounce(await this.get(false), 500);
			},
			async pageChg(page) {
				this.table.currentPage = page;
				await this.get(false);
			},
			async sortChg(ctx) {
				this.table.sort = ctx.sortBy;
				this.table.reverse = ctx.sortDesc;
				this.table.specialSort = undefined;

				await this.get(false);
			},
			async get(init = false) {
				this.page.errors = [];
				this.table.loading = true;

				try {
					if (init) {
						const responseF = await this.$http.get(`funds/list`, this.getTokenHeader());
						this.fiscalYear.options = responseF.data;
						if (this.fiscalYear.options.length > 0) {
							this.advancedFilter.fiscalYear = this.fiscalYear.options[0];
						}
					}

					const response = await this.getDb();
					this.log(response.data);

					if (response.data.items.length == 0 && this.table.currentPage > 1) {
						this.table.currentPage--;
						await this.get();
					}

					this.items = response.data.items;
					this.table.total = response.data.total;
				} catch (error) {
					if (this.isApiUnauthorized(error)) this.page.showLogin = true;
					else this.page.errors = this.logError(error);
				}

				this.table.loading = false;
				this.page.loading = false;
			},
			async find(field, query) {
				try {
					const response = await this.$http.get(`/omproposals/find/${field}/${query}`, this.getTokenHeader());
					this.advancedFilter.options[field] = response.data != '' ? response.data : [];
				} catch (error) {
					this.page.errors = this.logError(error);
				}
			},
			async findDams(field, query) {
				try {
					const response = await this.$http.get(`/dams/find/${field}/${query}`, this.getTokenHeader());
					this.advancedFilter.options.dam = response.data != '' ? response.data : [];
				} catch (error) {
					this.page.errors = this.logError(error);
				}
			},
			async clearFilter() {
				this.table.filter = null;
				await this.get();
			},
			async clearAdvancedFilter() {
				this.advancedFilter = {
					dam: null,
					//fiscalYear: null,
					sponsor: null,
					intendedStartDate: {
						start: null,
						end: null
					},
                    intendedEndDate: {
						start: null,
						end: null
					},
					isActive: null,
					options: {
						fiscalYear: [],
						sponsor: [],
						dam: []
					}
				};

				await this.get(false);
			}
		}
	}
</script>